module.exports = __webpack_public_path__ + "img/premiation-14-casa-de-luxo.15b4d042.png";